var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDcCharging = function SvgDcCharging(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1E242F",
    d: "M14.934 3H22l-4.462 6.32H22L11.365 21.144l3.643-8.03h-4.016z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1E242F",
    fillRule: "evenodd",
    d: "M11.344 9.32H8.546L13.008 3H5.942L2 13.113h4.016l-3.643 8.03 7.699-8.559z",
    clipRule: "evenodd"
  })));
};
export default SvgDcCharging;